import { render, staticRenderFns } from "./departmentStore.vue?vue&type=template&id=36ce709b&scoped=true&"
import script from "./departmentStore.vue?vue&type=script&lang=js&"
export * from "./departmentStore.vue?vue&type=script&lang=js&"
import style0 from "./departmentStore.vue?vue&type=style&index=0&id=36ce709b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ce709b",
  null
  
)

export default component.exports